function applyPanelUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (
    viewObjectSettings.items === undefined ||
    userViewObjectSettings.items === undefined ||
    viewObjectSettings.items.length != userViewObjectSettings.items.length
  ) {
    return;
  }
  for (let i = 0; i < viewObjectSettings.items.length; i++) {
    applyViewObjectUserSettings(viewObjectSettings.items[i], userViewObjectSettings.items[i]);
  }
}

function applyGridUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (
    viewObjectSettings.rows === undefined ||
    userViewObjectSettings.rows === undefined ||
    viewObjectSettings.rows.length != userViewObjectSettings.rows.length
  ) {
    return;
  }
  for (let rowIndex = 0; rowIndex < viewObjectSettings.rows.length; rowIndex++) {
    let rowSettings = viewObjectSettings.rows[rowIndex];
    let userRowSettings = userViewObjectSettings.rows[rowIndex];
    if (
      rowSettings.columns === undefined ||
      userRowSettings.columns === undefined ||
      rowSettings.columns.length != userRowSettings.columns.length
    ) {
      break;
    }
    for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
      let cellSettings = rowSettings.columns[columnIndex];
      let userCellSettings = userRowSettings.columns[columnIndex];
      applyViewObjectUserSettings(cellSettings.item, userCellSettings.item);
    }
  }
}

function applyColumnGridUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (
    viewObjectSettings.columns === undefined ||
    userViewObjectSettings.columns === undefined ||
    viewObjectSettings.columns.length != userViewObjectSettings.columns.length
  ) {
    return;
  }
  for (let columnIndex = 0; columnIndex < viewObjectSettings.columns.length; columnIndex++) {
    let columnSettings = viewObjectSettings.columns[columnIndex];
    let userColumnSettings = userViewObjectSettings.columns[columnIndex];
    if (
      columnSettings.rows === undefined ||
      userColumnSettings.rows === undefined ||
      columnSettings.rows.length != userColumnSettings.rows.length
    ) {
      break;
    }
    for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
      let cellSettings = columnSettings.rows[rowIndex];
      let userCellSettings = userColumnSettings.rows[rowIndex];
      applyViewObjectUserSettings(cellSettings.item, userCellSettings.item);
    }
  }
}

function applyTableUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (
    viewObjectSettings.items === undefined ||
    userViewObjectSettings.items === undefined ||
    viewObjectSettings.items.length != userViewObjectSettings.items.length
  ) {
    return;
  }
  for (let rowIndex = 0; rowIndex < viewObjectSettings.items.length; rowIndex++) {
    let rowItems = viewObjectSettings.items[rowIndex];
    let userRowItems = userViewObjectSettings.items[rowIndex];
    if (rowItems.length != userRowItems.length) {
      break;
    }
    for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
      let cellSettings = rowItems[columnIndex];
      let userCellSettings = userRowItems[columnIndex];
      applyViewObjectUserSettings(cellSettings, userCellSettings);
    }
  }
}

function applyPlotUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (userViewObjectSettings.defaultFilters !== undefined) {
    viewObjectSettings.defaultFilters = userViewObjectSettings.defaultFilters;
  }
  if (userViewObjectSettings.defaultScaleYIndex !== undefined) {
    viewObjectSettings.defaultScaleYIndex = userViewObjectSettings.defaultScaleYIndex;
  }
  if (userViewObjectSettings.defaultScaleXIndex !== undefined) {
    viewObjectSettings.defaultScaleXIndex = userViewObjectSettings.defaultScaleXIndex;
  }
}

function applyRhythmPlotUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (userViewObjectSettings.defaultFilters !== undefined) {
    viewObjectSettings.defaultFilters = userViewObjectSettings.defaultFilters;
  }
  if (userViewObjectSettings.defaultScaleYIndex !== undefined) {
    viewObjectSettings.defaultScaleYIndex = userViewObjectSettings.defaultScaleYIndex;
  }
  if (userViewObjectSettings.defaultScaleXIndex !== undefined) {
    viewObjectSettings.defaultScaleXIndex = userViewObjectSettings.defaultScaleXIndex;
  }
}

function applyViewObjectUserSettings(viewObjectSettings, userViewObjectSettings) {
  if (viewObjectSettings === undefined || userViewObjectSettings === undefined) {
    return;
  }
  switch (userViewObjectSettings.type) {
    case "panel":
      applyPanelUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
    case "grid":
      applyGridUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
    case "column-grid":
      applyColumnGridUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
    case "table":
      applyTableUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
    case "plot":
      applyPlotUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
    case "rhythm-plot":
      applyRhythmPlotUserSettings(viewObjectSettings, userViewObjectSettings);
      break;
  }
}

export function applyUserSettings(visSettings, userVisSettings) {
  if (userVisSettings.viewObjects === undefined || visSettings.viewObjects === undefined) {
    return;
  }
  for (let viewObjectIndex = 0; viewObjectIndex < visSettings.viewObjects.length; viewObjectIndex++) {
    applyViewObjectUserSettings(visSettings.viewObjects[viewObjectIndex], userVisSettings.viewObjects[viewObjectIndex]);
  }
}
